import { FormattedMessage } from 'react-intl';

import { UserId } from '@arrived/models';
import { useGetCurrentUserQuery, useGetMFADetailsQuery } from '@arrived/queries';

import { VerificationIndicator, VERIFICATION_STATUS } from '../accounts';

interface ProfileMFAVerificationIndicatorProps {
  userId?: UserId;
}

export const ProfileMFAVerificationIndicator = ({ userId }: ProfileMFAVerificationIndicatorProps) => {
  const currentUserState = useGetCurrentUserQuery({ enabled: userId === undefined });
  const mfaDetailsState = useGetMFADetailsQuery(userId ?? currentUserState.data?.id);
  if (mfaDetailsState.isLoading || mfaDetailsState.isError) return null;
  const isEnrolled = mfaDetailsState.data.enrollmentStatus === 'ENROLLED';
  return (
    <VerificationIndicator
      prefix={
        isEnrolled ? (
          <FormattedMessage
            id="profile.security.items.mfa.enrolledSecondary"
            defaultMessage="2-Step Verification: On"
          />
        ) : (
          <FormattedMessage
            id="profile.security.items.mfa.notEnrolledSecondary"
            defaultMessage="2-Step Verification: Off"
          />
        )
      }
      disableText
      status={isEnrolled ? VERIFICATION_STATUS.VERIFIED : VERIFICATION_STATUS.INCOMPLETE}
    />
  );
};
